import React from 'react';
import Media from 'react-media';
import { getMedia, defaultActionUrlCreator } from '../utilities';
import {
  ResponsiveRow,
  ImageCard,
  TextCard,
  ActionButton,
  IssueItem,
} from '../Elements';

export const TemplateOptions = {
  defaultMarginUnit: '1rem',
  maxIssueCount: 3,
  actionUrlCreator: defaultActionUrlCreator,
};

export const Admin = require('./Admin').default;

const AntmanTemplate = ({ page, match: { params } }) => {
  const { text, media, issues, actionBtn } = page;
  const issueCount = Math.min(issues.length, TemplateOptions.maxIssueCount);
  return (
    <Media query="(max-width: 769px)">
      {matches => (
        <div>
          <ResponsiveRow stacked={matches}>
            <ImageCard
              value={getMedia(media)}
              blockSize={1}
              blockStyle={{
                padding: matches
                  ? 0
                  : `0 ${TemplateOptions.defaultMarginUnit} ${TemplateOptions.defaultMarginUnit} 0`,
              }}
            />
            <TextCard
              blockSize={2}
              blockStyle={{
                padding: matches
                  ? `0 0 ${TemplateOptions.defaultMarginUnit}`
                  : `0 0 ${TemplateOptions.defaultMarginUnit} ${TemplateOptions.defaultMarginUnit}`,
              }}
            >
              {text}
            </TextCard>
          </ResponsiveRow>

          {issues &&
            <ResponsiveRow blockCount={issueCount} stacked={matches}>
              {issues.slice(0, issueCount).map(issue => (
                <IssueItem
                  key={issue.icon}
                  blockSize={1}
                  blockStyle={{
                    padding: matches
                      ? `${TemplateOptions.defaultMarginUnit} 0`
                      : `${TemplateOptions.defaultMarginUnit}`,

                    ':first-child': { paddingLeft: '0' },
                    ':last-child': { paddingRight: '0' },
                  }}
                  {...issue}
                />
              ))}
            </ResponsiveRow>}

          <ResponsiveRow
            stacked={matches}
            blockCount={3}
            style={{ justifyContent: 'center' }}
          >
            <ActionButton
              href={TemplateOptions.actionUrlCreator({ ...params, ...page })}
              size={1}
              style={{
                fontSize: '2.6rem',
                lineHeight: '2.6rem',
                padding: '2rem 3rem',
                height: 'auto',
                width: '100%',
              }}
              blockStyle={{
                padding: matches ? 0 : `${TemplateOptions.defaultMarginUnit}`,
              }}
              {...actionBtn}
            />
          </ResponsiveRow>
        </div>
      )}

    </Media>
  );
};

export default AntmanTemplate;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Antman/index.js